import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import FileDropArea from "./components/FileDropArea";
import FileOptions from "./components/FileOptions";
import ClipList from "./components/ClipList";
import VideoPlayer from "./components/VideoPlayer";
import { auth } from "./controllers/firebase";
import landing_video from "./assets/landing_video.mp4";
import landing_video_poster from "./assets/landing_video.webp";

function App() {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [isUserNomo, setIsUserNomo] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(setCurrentUser);
    return unsubscribe;
  }, [setCurrentUser]);

  useEffect(() => {
    const checkNomoClaim = async () => {
      const idTokenResult = await currentUser?.getIdTokenResult();
      setIsUserNomo(!!idTokenResult?.claims.nomo);
    };
    checkNomoClaim();
  }, [currentUser]);

  const loginScreen = () => {
    return (
      <div className="flex flex-col sm:flex-row pt-16 items-center h-full w-full">
        {seAceptanClips ? (
          <h1 className="text-5xl lg:w-1/2 lg:ml-32 m-10 lg:mt-10 mt-20 font-bold text-neutral-50 sm:leading-tight">
            <span className="underline decoration-wavy decoration-primary-700 drop-shadow-md">
              Inicia sesión
            </span>{" "}
            para enviar tus{" "}
            <span className="text-primary-700 drop-shadow-md">clips</span>
          </h1>
        ) : (
          <h1 className="text-5xl lg:w-1/2 lg:ml-32 m-10 lg:mt-10 mt-20 font-bold text-neutral-50 sm:leading-tight">
            Ya no se aceptan{" "}
            <span className="text-primary-700 drop-shadow-md">clips</span>
          </h1>
        )}
        <video
          src={landing_video}
          autoPlay
          disableRemotePlayback
          loop
          muted
          poster={landing_video_poster}
          className="w-5/6 sm:w-1/2 object-cover rounded-3xl m-2 right-0 sm:mr-28 shadow-md"
        ></video>
      </div>
    );
  };

  const seAceptanClips = false;

  return (
    <div className="text-gray-50 h-full w-full">
      <Header currentUser={currentUser} />
      {!seAceptanClips || currentUser === null || !isUserNomo ? (
        loginScreen()
      ) : (
        <>
          <div
            className={`pt-16 bg-gray-800 sm:h-full flex w-full ${
              selectedVideo ? "" : "sm:pb-56"
            }`}
          >
            <main className="relative h-full w-full sm:pr-96 py-4 flex flex-col sm:flex-row items-stretch">
              {selectedVideo ? (
                <VideoPlayer
                  video={selectedVideo.url}
                  setSelectedVideo={setSelectedVideo}
                />
              ) : (
                <>
                  <FileDropArea
                    setFile={setFile}
                    file={file}
                    progress={progress}
                    error={error}
                  />
                  <FileOptions
                    setFile={setFile}
                    file={file}
                    userEmail={currentUser?.email}
                    setProgress={setProgress}
                    setError={setError}
                  />
                </>
              )}
            </main>
          </div>
          <ClipList
            userEmail={currentUser?.email}
            selectedVideo={selectedVideo}
            setSelectedVideo={setSelectedVideo}
          />
        </>
      )}
    </div>
  );
}

export default App;
